<script lang="ts">
	if (window.opener && window.opener !== window) {
		window.close();
	}

	async function openPopup(url: string) {
		const width = 500;
		const height = 800;
		const xPos = window.screenX + window.outerWidth / 2;
		const yPos = window.screenY + window.outerHeight / 2 - height / 2;
		const popup = window.open(
			url,
			"Mother Mouse Twitch Auth",
			`width=${width},height=${height},resizable=yes,scrollbars=yes,location=yes,menubar=no,left=${xPos},top=${yPos}`
		);
		if (!popup) {
			location.href = url;
			return;
		}

		await new Promise((resolve) => {
			setInterval(() => popup.closed && resolve(null), 200);
		});
	}
</script>

<main class="text-center">
	<h1 class="text-2xl font-bold bg-indigo-200 mb-3">Mother Mouse Twitch</h1>
	<div class="auth-buttons">
		<button class="twitch" on:click={() => openPopup("/login/twitch")}>Login with Twitch</button>
		<button class="streamlabs" on:click={() => openPopup("/login/streamlabs")}>Login with Streamlabs</button>
	</div>
</main>

<style lang="postcss" global>
	@tailwind base;
	@tailwind components;
	@tailwind utilities;

	:root {
		--twitch: #9146ff;
		--textcolor: #000;
	}

	@keyframes twitch {
		10% {
			transform: rotate(5deg);
		}
		30% {
			transform: rotate(-5deg);
		}
		50% {
			transform: rotate(5deg);
		}
		70% {
			transform: rotate(-5deg);
		}
		90% {
			transform: rotate(5deg);
		}
		100% {
			transform: rotate(0deg);
		}
	}

	.twitch {
		padding: 10px;
		color: #f0f0ff;
		text-align: center;
		text-decoration: none;
		background-color: var(--twitch);
		animation: twitch 500ms normal;
	}

	.streamlabs {
		padding: 10px;
		color: #f0f0ff;
		text-align: center;
		text-decoration: none;
		background-color: #80f5d2;
		color: #111;
	}

	.auth-buttons {
		display: flex;
		flex-wrap: wrap;
		align-items: center;
		justify-content: center;
		margin: 0 auto;
		max-width: 600px;
		gap: 20px;
	}
</style>
